<template>
  <div id="contenedor-infraestructura-configuracion-opciones-tool-bar">
    <v-tabs>
      <template
        v-for="(opcion, index) in opciones">
        <template>
          <v-tab
            :key="index"
            :to="{ name: opcion.ruta }"
            exact>
            {{ opcion.nombre }}
          </v-tab>
        </template>
      </template>
    </v-tabs>
  </div>
</template>

<script>
export default {
  name: 'InfraestructuraConfiguracionOpcionesToolBar',
  data() {
    return {
      opciones: [
        {
          nombre: 'Tipos Infraestructura',
          ruta: 'infraestructuraConfiguracionTiposInfraestructura',
          icono: '',
        },
        {
          nombre: 'Subtipos Infraestructura',
          ruta: 'infraestructuraConfiguracionSubtiposInfraestructura',
          icono: '',
        },
        {
          nombre: 'Caracteristicas Subtipos infraestructura',
          ruta: 'infraestructuraConfiguracionCaracteristicasSubtiposInfraestructura',
          icono: '',
        },
      ],
    };
  },
};
</script>

<style lang="scss">

</style>
